import { SxProps, Theme } from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";

interface ButtonComponentsProps {
  label: string;
  onClick: () => void;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  datatestid?: string;
  sx?: SxProps<Theme>;
}

const ButtonComponents: React.FC<ButtonComponentsProps> = ({
  label,
  onClick,
  variant = "contained",
  color = "primary",
  size = "medium",
  disabled = false,
  datatestid,
  sx,
}) => {
  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      onClick={disabled ? () => { } : onClick}
      data-testid={datatestid}
      sx={{
        mx: 1,  // This is margin left and right, you can also specify 'ml' and 'mr' separately.
        borderRadius: 1,
        border: !disabled ? "1px solid #FF5C39" : "",
        bgcolor: disabled ? "#9FA4AB" : variant === "outlined" ? "#fff" : "#FF5C39",
        color: variant !== "outlined" ? "#fff" : "#FF5C39",
        boxShadow: "none",
        fontSize: 12,
        textTransform: "capitalize",
        '&:hover': {
          cursor: !disabled ? "pointer" : "text",
          boxShadow: "none",
          backgroundColor: disabled ? "#9FA4AB" : '#e65232',
          color: "#FFF"
        },
        ...sx, // Merge additional styles
      }}
      aria-label={label}  // Accessible name for the button
      aria-disabled={disabled} // Indicate if button is disabled
    >
      {label}
    </Button>
  );
};

export default ButtonComponents;
